:host {
  --buttons-width: 100px;
  --textarea-max-width: 800px;
}

.buttons-wrapper {
  height: calc(var(--spacer) * 4);
  width: var(--buttons-width);

  #send-button,
  #clear-button {
    cursor: pointer;
  }
}

.main-wrapper {
  position: relative;
}

.max-width-900 {
  width: fit-content;
  max-width: calc(var(--buttons-width) + var(--textarea-max-width));
}

#textarea-form-field {
  max-width: var(--textarea-max-width);
}

#textarea {
  height: 68px;
}

gz-input-error {
  padding-left: calc(var(--spacer) / 2);
}

gz-textarea::part(counter) {
  font-family: 'Roboto', sans-serif;
  padding-right: 0;
  -webkit-transition: color 100ms;
  transition: color 100ms;
}

gz-textarea {
  --text-area-white-space: pre-wrap;
}

:host([hasErrorState]) {
  gz-textarea::part(counter) {
    color: var(--red-layout-300-primary);
  }

  .hint-text {
    color: var(--red-layout-300-primary);
  }
}

#suggestion-overlay {
  max-height: 290px;
  border-radius: calc(var(--spacer) / 2);
  border: 1px solid var(--blue-layout-301-active);
  background: var(--white-layout-301-level-0-elevation);
  position: absolute;
  overflow: hidden;
  display: none;

  #list-wrapper {
    width: 100%;
    height: 100%;
    overflow-y: scroll;

    ul {
      max-height: 290px;

      li {
        cursor: pointer;
        padding: calc(var(--spacer) - 1px) calc(var(--spacer) + 3px);
        font-size: var(--body-size);
        line-height: 18px;
        color: var(--main-titles-inputs-600);

        &:hover {
          background-color: var(--chart-051-hover);
        }

        &.disabled {
          color: var(--grey-layout-200-disabled);
          pointer-events: none;

          gz-tooltip {
            pointer-events: none;
          }

          gz-button {
            pointer-events: initial;
          }
        }
      }
    }
  }
}

.hidden-action-button {
  display: block;
  position: absolute;
  top: 10px;
  visibility: hidden;
}

:host([isOpen]) {
  #suggestion-overlay {
    display: block;
  }
}

.bold {
  font-weight: bold;
}

.hint-text {
  padding: 2px 0 0 calc(var(--spacer) * 1.5);
  color: var(--body-text-arrows-400);
  font-weight: 400;
  font-family: var(--font-family-secondary);
  transition: opacity 100ms ease-in-out, transform 200ms ease-out;
  opacity: 0;
  transform-origin: center top;
  transform: translateY(-10%) scaleY(0);
  font-size: var(--body-size);

  &.visible-hint {
    opacity: 1;
    transform: translateY(0) scaleY(1);
    height: auto;
  }
}

:host([inputWidth='full']) {
  #textarea-form-field,
  .max-width-900 {
    width: 100%;
  }
}
